<template>
    <div class="container containerManage ml10 mr10">
        <div class="top mt20">
            <el-button type="primary"  size="small" icon="el-icon-circle-plus-outline" v-if="permission.sys_role_add" @click="handleAdd">{{$t('userManage.newAdd')}}</el-button>
        </div>
        <div class="contentBox mt20">
            <el-table :data="tableData" border style="width: 100%" 
            default-expand-all
              row-key="id"
            :tree-props="{children: 'children', hasChildren: 'true'}"
            v-loading="loading">
                <!-- <el-table-column label="序号" width="100" align="center">
                    <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                </el-table-column> -->
                
                
                <el-table-column
                    v-for="(item, index) in columnlist"
                    :key="index"
                 
                    :prop="item.prop"
                    :label="item.label"
                    :width="item.width"
                    :min-width="item.minWidth"
                    align="center"
                >
                </el-table-column>
                <el-table-column :label="$t('realdetile.opera')" align="center" width="280">
                    <template slot-scope="scope"> 
                     
                        <el-button type="text" size="small" icon="el-icon-edit" plain v-if="permission.sys_role_edit" @click="handleEdit(scope.$index, scope.row)">{{$t('roleManage.revise')}}</el-button>
                        <el-button type="text" size="small" icon="el-icon-delete" plain v-if="permission.sys_role_del" @click="handleDel(scope.$index, scope.row)">{{$t('alarmSetting.delete')}}</el-button>
                        <el-button type="text" size="small" icon="el-icon-magic-stick" plain v-if="permission.sys_role_allot " @click="handleAuth(scope.$index, scope.row)">+ {{$t('route.permission')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- <div class="page txtr mt10">
            <el-pagination
                background
                :current-page.sync="page.current"
                @current-change="handleCurrentChange"
                layout="total, prev, pager, next"
                :total="page.total"
            >
            </el-pagination>
        </div> -->
        <el-dialog
            class="roleForm"
            :title="form.title"
            :visible.sync="form.dialogFormVisible"
            :before-close="handleCancel"
            width="600px"
            center
        >
            <el-form id="custom-form" class="flex" :model="form.formItem" :rules="form.rules" ref="ruleForm" label-width="120px">
                <el-form-item :label="$t('userManage.roleName')" prop="roleName">
                    <el-input v-model="form.formItem.roleName" ></el-input>
                </el-form-item>
                 <el-form-item :label="$t('roleManage.parentRole')" prop="parentId" v-if="istrue">
                     <Selecttree 
                        :props="prop"
                        style="width:100%"
                        :options="tableData"
                        :value="form.formItem.parentId"
                        :clearable="isClearable"
                        :accordion="isAccordion"
                        @getValue="getValue($event)"
                     />
                </el-form-item>
                
                <el-form-item :label="$t('roleManage.roleDescription')" prop="roleDesc">
                    <el-input
                        type="textarea"
                        v-model="form.formItem.roleDesc"
                      
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="button--cancel" size="small" @click="closeDia">{{$t('manipulation.cancel')}}</el-button>
                <el-button type="primary" size="small" @click="handleSubmit">{{$t('manipulation.sure')}}</el-button>
            </div>
        </el-dialog>
        <el-dialog
            :title="$t('userManage.revisePer')"
            class="authForm"
            :visible.sync="auth.dialogAuthVisible"
            :before-close="handleAuthCancel"
            check-strictly
            width="600px"
            center
        >
            <el-tree
                :data="auth.menuData"
                show-checkbox
                node-key="id"
                ref="tree"
                :default-expanded-keys="auth.activeMenuData"
                :default-checked-keys="auth.activeMenuData"
                :props="auth.defaultProps"
            >
            </el-tree>
            <div slot="footer" class="dialog-footer">
                <el-button class="button--cancel" size="small" @click="closeAuth">{{$t('manipulation.cancel')}}</el-button>
                <el-button type="primary" size="small" @click="handleAuthSubmit">{{$t('manipulation.sure')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { fetchList, addObj, putObj, delObj ,deptRoleList} from '@/api/admin/role';
import { getAllMenu, getRoleMenu, setRoleMenu,getRole } from '@/api/admin/role';
import Selecttree from '@/components/treeSelect'
import { mapGetters } from 'vuex';
export default {
    name: 'roleManage',
    components: {
        // roleForm: () => import('./roleForm'),
        // authForm: () => import('./authForm')
        Selecttree
    },
    data() {
        return {
            param: {
                page: {
                    current: 1,
                    size: 10
                },
                roleId: '',
                menuIds: []
            },
            loading: false,
            tableData: [],
            columnlist: Object.freeze([
                // { prop: 'roleId', label: '序号' },
                { prop: 'title', label: this.$t('userManage.roleName') },
                { prop: 'roleDesc', label: this.$t('roleManage.roleDescription') },
                { prop: 'createTime', label: this.$t('roleManage.createTime') }
            ]),
            page: {
                current: 1,
                size: 10,
                total: 0,
                pages: 1
            },
            form: {
                dialogFormVisible: false,
                title: '',
                formItem: {
                    parentId: '',
                    roleName: '',
                    roleDesc: '',
                    roleCode: ''
                },
                rules: Object.freeze({
                    roleName: [{ required: true, message: this.$t('userManage.addRoleName'), trigger: 'blur' }],
                    roleDesc: [{ required: true, message: this.$t('userManage.addRoleDes'), trigger: 'blur' }],
                    parentId: [{ required: true, message: this.$t('userManage.addUpRole'), trigger: 'blur' }]
                })
            },
            auth: {
                dialogAuthVisible: false,
                menuData: [],
                parentIds: [],
                activeMenuData: [],
                defaultProps: {
                    children: 'children',
                    label: 'title'
                }
            },
            sys_role_add: true,
            sys_role_edit: true,
            sys_role_del: true,
            sys_role_perm: true,
            prop:{
                value:'id',
                label:'title'
            },
            isClearable: true, // 可清空（可选）
            isAccordion: true,
            istrue:true
        };
    },
    computed: {
        ...mapGetters(['permission'])
    },
    created() {
        this.init();
    },
    mounted() {
      let that = this
    
    //   setTimeout(function(){
    //     that.permissions['sys_role_add'] && (that.sys_role_add = that.permissions['sys_role_add']);
    //     that.permissions['sys_role_edit'] && (that.sys_role_edit = that.permissions['sys_role_edit']);
    //     that.permissions['sys_role_del'] && (that.sys_role_del = that.permissions['sys_role_del']);
    //     that.permissions['sys_role_perm'] && (that.sys_role_perm = that.permissions['sys_role_perm']);
    //   },1000)
    },
    methods: {
        getValue(e){
            this.form.formItem.parentId =e
        },
        init() {
            this.getRoleData();
        },
        // 获取角色数据
        getRoleData() {
            // this.loading = true;
            deptRoleList(this.param.page).then(res => {
                res = res.data.data;
                // res.records.map((item,index)=>{
                //     if(item.createTime){
                //         item.createTime = item.createTime.split(' ')[0]
                //     }
                // })
                this.tableData = res;
             
                // this.loading = false;
                // const { total, pages, current, size } = res;
                // this.page = { total, pages, current, size };
            });
        },
        // 分页导航
        handleCurrentChange(val) {
            this.param.page.current = val;
            this.getRoleData();
        },
        // 新增角色的表单
        handleAdd() {
            this.form.title = this.$t('userManage.addUpRole');
            this.form.formItem.roleCode = this.getRandomCode(8);
            this.form.dialogFormVisible = true;
            // FIXME: 后台的创建时间不对
        },
        // 修改角色的表单
        handleEdit(index, row) {
           
            if(row.id =='1'){
                this.istrue = false
            }else{
                this.istrue = true
            }
            this.form.title = this.$t('userManage.reviseRole');
            this.form.dialogFormVisible = true;
            const { id, roleName, roleDesc, roleCode ,parentId } = row;
            this.form.formItem = { id, roleName, roleDesc, roleCode ,parentId};
        },
        // 提交表单
        handleSubmit() {
            if (this.form.title === this.$t('userManage.addUpRole')) {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        addObj(this.form.formItem).then(res => {
                            if (res.data.code === 200) {
                                this.$message.success(this.$t('alarmSetting.addSuc'));
                                this.getRoleData();
                            } else {
                                this.$message.error(this.$t('alarmSetting.addFauRepeat'));
                            }
                            this.closeDia();
                        });
                    } else {
                        this.$message.warning(this.$t('alarmSetting.fillComplete'));
                        return;
                    }
                });
            } else {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        putObj(this.form.formItem).then(res => {
                            if (res.data.code === 200) {
                                this.$message.success(this.$t('alarmSetting.chaSuc'));
                                this.getRoleData();
                            } else {
                                this.$message.error(this.$t('alarmSetting.chaFauRepeat'));
                            }
                            this.closeDia();
                        });
                    } else {
                        this.$message.warning(this.$t('alarmSetting.fillComplete'));
                        return;
                    }
                });
            }
        },
        handleCancel(done) {
            this.form.formItem = {};
            this.istrue= true
           
            done();
        },
        closeDia() {
            this.form.formItem = {};
           
            this.istrue= true
            this.form.dialogFormVisible = false;
        },
        // 删除角色
        handleDel(index, row) {
            // 二次确认删除
            this.$confirm(this.$t('alarmSetting.promptContent')+"?", this.$t('alarmSetting.prompt'), {
                type: 'warning'
            })
                .then(() => {
                    delObj({ids: row.id}).then(res => {
                        if (res.data.code === 200) {
                            this.$message.success(this.$t('alarmSetting.deleteSuc'));
                            this.getRoleData();
                        } else {
                            this.$message.error(this.$t('alarmSetting.deleteFau'));
                        }
                    });
                })
                .catch(() => {});
        },

        /**
         * 权限功能
         */
        // 获取角色权限菜单
        getMenuData() {
            // 获取全部菜单
            getAllMenu().then(res => {
                if (res.data.code === 200) {
                    this.auth.menuData = res.data.data.menu;
                    
                    // 获取选中菜单权限
                    getRole(this.param.roleId).then(res => {
                        this.auth.activeMenuData = res.data.data.menu;
                        this.auth.dialogAuthVisible = true;
                    });
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },

        // 权限修改表单
        handleAuth(index, row) {
            this.auth.activeMenuData.length = 0;
            this.param.roleId = row.id;
            this.getMenuData();
            if (this.auth.activeMenuData.length === 0) {
                // 在分配电站时就设置默认电站
            }
        },
        handleAuthSubmit() {
            const totalNode = this.$refs.tree.getCheckedKeys().toString();
            console.log(this.param,'--params',this.$refs.tree.getCheckedKeys(),this.$refs.tree.getHalfCheckedKeys())
            setRoleMenu(this.param.roleId, totalNode).then(res => {
                if (res.data.code === 200) {
                    this.$message.success(this.$t('roleManage.updateSuc'));
                } else {
                      this.$message.error(this.$t('roleManage.upDateFauRepeat'));
                }
                this.closeAuth();
            });
        },
        handleAuthCancel(done) {
            this.auth.activeMenuData = [];
            done();
        },
        closeAuth() {
            this.auth.activeMenuData = [];
            this.auth.dialogAuthVisible = false;
        },

        // 功能函数
        getRandomCode(length) {
            if (length > 0) {
                var data = [
                    '0',
                    '1',
                    '2',
                    '3',
                    '4',
                    '5',
                    '6',
                    '7',
                    '8',
                    '9',
                    'A',
                    'B',
                    'C',
                    'D',
                    'E',
                    'F',
                    'G',
                    'H',
                    'I',
                    'J',
                    'K',
                    'L',
                    'M',
                    'N',
                    'O',
                    'P',
                    'Q',
                    'R',
                    'S',
                    'T',
                    'U',
                    'V',
                    'W',
                    'X',
                    'Y',
                    'Z',
                    'a',
                    'b',
                    'c',
                    'd',
                    'e',
                    'f',
                    'g',
                    'h',
                    'i',
                    'j',
                    'k',
                    'l',
                    'm',
                    'n',
                    'o',
                    'p',
                    'q',
                    'r',
                    's',
                    't',
                    'u',
                    'v',
                    'w',
                    'x',
                    'y',
                    'z'
                ];
                var nums = '';
                for (var i = 0; i < length; i++) {
                    var r = parseInt(Math.random() * 61);
                    nums += data[r];
                }
                return nums;
            } else {
                return false;
            }
        },
        isInArray(arr, value) {
            if (arr.indexOf && typeof arr.indexOf == 'function') {
                var index = arr.indexOf(value);
                if (index >= 0) {
                    return true;
                }
            }
            return false;
        }
    }
};
</script>

<style lang="scss" scoped>
.containerManage{
  overflow-y: auto;
  box-sizing: border-box;
  width: calc(100% - 20px);
}
.authForm {
    .el-tree {
        height: 500px;
        overflow: auto;
    }
    
}
</style>
